import { FaReact, FaNodeJs, FaHtml5, FaSass } from 'react-icons/fa'
import { IoLogoJavascript } from 'react-icons/io'
import {
  SiRedux,
  SiCss3,
  SiNextdotjs,
  SiTypescript,
  SiPostman,
  SiBootstrap,
  SiMui,
  SiPwa,
  SiElectron,
} from 'react-icons/si'

import { AiFillAndroid } from 'react-icons/ai'
import { ImGit } from 'react-icons/im'
// @ts-ignore
import React from 'react'

interface SkillsType {
  name: string
  icon: any
  link: string
}

export const FrontEndSkillsData: SkillsType[] = [
  {
    name: 'JavaScript',
    icon: <IoLogoJavascript color="#ffffffdc" />,
    link: 'https://www.javascript.com/',
  },
  {
    name: 'TypeScript',
    icon: <SiTypescript color="#ffffffdc" />,
    link: 'https://www.typescriptlang.org/',
  },
  {
    name: 'React',
    icon: <FaReact color="#ffffffdc" />,
    link: 'https://reactjs.org/',
  },
  {
    name: 'Next.js',
    icon: <SiNextdotjs color="#ffffffdc" />,
    link: 'https://nextjs.org/',
  },
  {
    name: 'Redux',
    icon: <SiRedux color="#ffffffdc" />,
    link: 'https://redux.js.org/',
  },
  {
    name: 'Node.js',
    icon: <FaNodeJs color="#ffffffdc" />,
    link: 'https://nodejs.org/',
  },
  {
    name: 'HTML',
    icon: <FaHtml5 color="#ffffffdc" />,
    link: 'https://www.w3schools.com/html/',
  },
  {
    name: 'CSS',
    icon: <SiCss3 color="#ffffffdc" />,
    link: 'https://www.w3schools.com/css/',
  },
  {
    name: 'SASS',
    icon: <FaSass color="#ffffffdc" />,
    link: 'https://sass-lang.com/',
  },
  {
    name: 'Bootstrap',
    icon: <SiBootstrap color="#ffffffdc" />,
    link: 'https://getbootstrap.com/',
  },
  {
    name: 'Material-Ui',
    icon: <SiMui color="#ffffffdc" />,
    link: 'https://mui.com/',
  },
]
